<div class="modal" *ngIf="formControl">
    <i class="fal fa-times modal__close" (click)="close()"></i>
    <h2 class="mb-0075"> {{isCreate ? 'Create' : 'Update'}} Address</h2>
    <app-address-form
    [formControl]="formControl"
    [hideConfirmedCheckbox]="false">
    </app-address-form>

    <div class="col__ mt-0075" content-outlet="buttons">
        <button class="btn floatRight" type="button"
        data-test-id="saveAddressButton"
        [appButtonSpinner]="isSaving"
        [disabled]="!formControl?.valid || isSaving"
        (click)="onSaveClicked()"
        >Save</button>
    </div>

</div>
